import { getLocaleStore } from './index';

const isDesignkitIntl = process.env.REACT_APP_NAME === 'designkit' && process.env.REACT_APP_IS_INTL === '1';

/**
 * 一些功能配置资源
 */
export function getConfigAssets() {
    const locale = getLocaleStore().locale;

    function getPrefix(isIntl: boolean, env = process.env.REACT_APP_ENV) {
        switch (env) {
            case 'development':
            case 'pre':
                return isIntl ? 'pre' : 'pre-';
            case 'beta':
                return isIntl ? '' : 'beta-';
            case 'production':
            case 'release':
            default:
                return '';
        }
    }

    if (isDesignkitIntl || locale === 'zh-Hans') {
        return {
            /** 获取字体子集服务 */
            fontTool: `https://${getPrefix(false)}font-tool.meitu.com/subset/file`,
        };
    }

    return {
        /** 获取字体子集服务 */
        fontTool: `https://${getPrefix(true)}font-tool.starii.com/subset/file`,
    };
}

/**
 * 使用素材中心地址
 * 会被写到配方里的资源
 */
export function getMaterialAssets() {
    const locale = getLocaleStore().locale;

    if (isDesignkitIntl || locale === 'zh-Hans') {
        return {
            /** 表格图层 */
            tableLayer: {
                /** 默认缩略图 */
                screenshotUrl: {
                    table1: `https://material-center.meitudata.com/material/image/65fa93c297b4e6782.png`,
                    table2: `https://material-center.meitudata.com/material/image/65fa93b3de8264726.png`,
                    table3: `https://material-center.meitudata.com/material/image/65fa938fe381f4928.png`,
                    table4: `https://material-center.meitudata.com/material/image/65fa9383da1653278.png`,
                    table5: `https://material-center.meitudata.com/material/image/65fa9374cbe6c4459.png`,
                    table6: `https://material-center.meitudata.com/material/image/65fa93670800e3101.png`,
                    table7: `https://material-center.meitudata.com/material/image/65fa935be47bd7626.png`,
                    table8: `https://material-center.meitudata.com/material/image/65fa93501702c838.png`,
                    table9: `https://material-center.meitudata.com/material/image/65fa9335101782066.png`,
                },
            },
            /** 图表图层 */
            chartLayer: {
                /** 默认缩略图 */
                screenshotUrl: {
                    'bar-basic': 'https://xiuxiu-pro.meitudata.com/posters/6d2e5cac13a490641ad66c32d04eb973.png',
                    'bar-horizontal-basic':
                        'https://xiuxiu-pro.meitudata.com/posters/662f35bacd86b20abc53efd012edff93.png',
                    'bar-horizontal-stacked':
                        'https://xiuxiu-pro.meitudata.com/posters/168e59922762860f20d4064d158ba669.png',
                    'bar-stacked': 'https://xiuxiu-pro.meitudata.com/posters/c77fcd93be172b59dfbfe646e6a690e2.png',
                    'line-basic': 'https://xiuxiu-pro.meitudata.com/posters/73f107d2f80d7cf96cf06aad72f99018.png',
                    'pie-basic': 'https://xiuxiu-pro.meitudata.com/posters/5428810be3c0921eca8975ccb565a5cc.png',
                    'pie-doughnut': 'https://xiuxiu-pro.meitudata.com/posters/3a44ba67ca71eeee49b198d67cf1c78a.png',
                },
            },
            /** 图片图层 */
            imageLayer: {
                /** 空白遮罩 */
                maskURL: 'https://material-center.meitudata.com/material/image/61615aef9f64d8971.png',
            },
        };
    }
    return {
        /** 表格图层 */
        tableLayer: {
            /** 默认缩略图 */
            screenshotUrl: {
                table1: `https://material-center.meitudata.com/material/image/65fa93c297b4e6782.png`,
                table2: `https://material-center.meitudata.com/material/image/65fa93b3de8264726.png`,
                table3: `https://material-center.meitudata.com/material/image/65fa938fe381f4928.png`,
                table4: `https://material-center.meitudata.com/material/image/65fa9383da1653278.png`,
                table5: `https://material-center.meitudata.com/material/image/65fa9374cbe6c4459.png`,
                table6: `https://material-center.meitudata.com/material/image/65fa93670800e3101.png`,
                table7: `https://material-center.meitudata.com/material/image/65fa935be47bd7626.png`,
                table8: `https://material-center.meitudata.com/material/image/65fa93501702c838.png`,
                table9: `https://material-center.meitudata.com/material/image/65fa9335101782066.png`,
            },
        },
        /** 图表图层 */
        chartLayer: {
            /** 默认缩略图 */
            screenshotUrl: {
                'bar-basic': 'https://x-design-release.stariidata.com/posters/0f3c66b29fed30c58e10b99e383c08ac.png',
                'bar-horizontal-basic':
                    'https://x-design-release.stariidata.com/posters/e3dddd4715c099ef51dec41dc14e24b3.png',
                'bar-horizontal-stacked':
                    'https://x-design-release.stariidata.com/posters/5abd7216797651cd294313e36e26a042.png',
                'bar-stacked': 'https://x-design-release.stariidata.com/posters/e1364a4ad9a2aebb90919a55f55d0992.png',
                'line-basic': 'https://x-design-release.stariidata.com/posters/d305d72dd6c628571c61030868720372.png',
                'pie-basic': 'https://x-design-release.stariidata.com/posters/25fb6707038fd0a0c1e67a179e6b4581.png',
                'pie-doughnut': 'https://x-design-release.stariidata.com/posters/ca034b880919ea866200c854dd821402.png',
            },
        },
        /** 图片图层 */
        imageLayer: {
            /** 空白遮罩 */
            maskURL: 'https://material-center.meitudata.com/material/image/61615aef9f64d8971.png',
        },
    };
}

/**
 * 较大文件，不适合放在项目里的
 */
export function getBigAssets() {
    const locale = getLocaleStore().locale;
    switch (locale) {
        case 'en':
            return {};
        case 'zh-Hans':
        default:
            return {};
    }
}

/**
 * 一些外链资源
 */
export function getLinksAssets() {
    return {
        download: 'https://pc.meitu.com/download',
    };
    // const locale = getLocaleStore().locale;
    // switch (locale) {
    //     case 'en':
    //         return {
    //             download: 'https://pc.meitu.com/download',
    //         };
    //     case 'cn':
    //     default:
    //         return {
    //             download: 'https://pc.meitu.com/download',
    //         };
    // }
}
